var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "list-square",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: "icon line",
    width: 96,
    height: 96,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    id: "primary-upstroke",
    x1: 7.45,
    y1: 8,
    x2: 7.55,
    y2: 8,
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.3
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "primary-upstroke-2",
    "data-name": "primary-upstroke",
    x1: 7.45,
    y1: 12,
    x2: 7.55,
    y2: 12,
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.3
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "primary-upstroke-3",
    "data-name": "primary-upstroke",
    x1: 7.45,
    y1: 16,
    x2: 7.55,
    y2: 16,
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M4,3H20a1,1,0,0,1,1,1V20a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V4A1,1,0,0,1,4,3Zm8,5h5m-5,4h5m-5,4h5",
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.b7ba2b2c6cfbc8bbddc7542cc1475f22.svg";
export { ForwardRef as ReactComponent };